import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '1.5rem',
    height: '1.5rem',
  },
});

const ChartIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon}>
      <path d="M5.4 16.0498H1.5V19.0498H5.4V16.0498Z" />
      <path d="M13.95 16.0498H10.05V19.0498H13.95V16.0498Z" />
      <path opacity="0.7" d="M22.5 16.0498H18.6V19.0498H22.5V16.0498Z" />
      <path d="M5.4 10.6499H1.5V13.6499H5.4V10.6499Z" />
      <path opacity="0.7" d="M13.95 10.6499H10.05V13.6499H13.95V10.6499Z" />
      <path d="M22.5 10.6499H18.6V13.6499H22.5V10.6499Z" />
      <path opacity="0.7" d="M5.4 5.3999H1.5V8.3999H5.4V5.3999Z" />
      <path d="M13.95 5.3999H10.05V8.3999H13.95V5.3999Z" />
      <path d="M5.4 0H1.5V3H5.4V0Z" />
      <path d="M24 21H0V24H24V21Z" />
    </SvgIcon>
  );
};

export default memo(ChartIcon);
